import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const options = [
  { label: 'Biochemical NBS Test Results', value: 'biochemical' },
  { label: 'Disease Risk Scatterplot for Flagged Conditions', value: 'disease_risk_scatterplot' },
  { label: 'Single Analyte Patient Analysis', value: 'single_analyte_analysis' },
  // Add more options here if needed
];

const PatientDetailsSelectDataView = ({ selectedDataView, setSelectedDataView, classes }) => (
  <Autocomplete
    fullWidth
    className={classes.muiInputs}
    options={options}
    value={options.find(opt => opt.value === selectedDataView) || null}
    onChange={(event, newValue) => setSelectedDataView(newValue ? newValue.value : null)}
    getOptionLabel={option => option.label}
    renderInput={params => (
      <TextField {...params} label="Select Data to View" variant="outlined" size="small" />
    )}
    isOptionEqualToValue={(option, value) => option.value === value?.value}
  />
);

export default PatientDetailsSelectDataView;